'use client';

import { ZERO } from '@drift-labs/sdk';
import { useMemo } from 'react';
import { useCurrentAccountPositions } from './query/accountTradingData/usePositions';

const useCurrentAccountOpenPerpPositions = () => {
	const openPerpPositions = useCurrentAccountPositions();

	const filteredPositions = useMemo(() => {
		if (!openPerpPositions || openPerpPositions.length === 0) return [];

		return openPerpPositions.filter((pos) => !pos.baseSize.eq(ZERO));
	}, [openPerpPositions]);

	return filteredPositions;
};

export default useCurrentAccountOpenPerpPositions;
